// @flow
import { COUNTRY_INFOS } from 'Client/cms/toolkit/constants';
import { CountryInfosLine } from 'Components/lines/country-infos-line/CountryInfosLine';
import { countryInfosResolver } from './countryInfos.resolver';

export const countryInfosDescriptor = {
  name: COUNTRY_INFOS,
  component: CountryInfosLine,
  resolve: countryInfosResolver.resolve,
};
